import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 中英文案（删除重复的email键）
const resources = {
    en: {
        translation: {
            // 导航
            home: "Home",
            services: "Services",
            contact: "Contact",
            navForInfluencers: "For Influencers",
            navHomeAria: "The Jasper Hub Home",
            navLogoAlt: "The Jasper Hub",
            navOpenMenu: "Open navigation menu",
            navCloseMenu: "Close navigation menu",
            navMainAria: "Main navigation",
            navPortal: "Portal",
            siteTitle: "The Jasper Hub | App Growth & Influencer Marketing Agency",
            siteDescription: "Global influencer marketing and data-led growth strategies connecting brands with creators and audiences worldwide.",
            getStarted: "GET STARTED",
            forInfluencers: "FOR INFLUENCERS",
            footerForInfluencers: "For Influencers",
            footerBrand: "The Jasper Hub",
            footerAgencyBadge: "Agency",
            footerDescription: "Global Influencer Marketing Partner. Fueling viral brand expansion, performance talent acquisition, and precision influencer campaigns across global territories.",
            footerActivity: "Cross-Border Campaigns Active",
            footerContact: "Contact",
            footerBusinessEnquiries: "Business Enquiries",
            footerInfluencerQueries: "Influencer Queries",
            footerHeadquarters: "Headquarters",
            footerLinks: "Links",
            footerNavigation: "Footer links",
            loading: "Loading...",
            homeWhyChooseDesc: "We provide comprehensive solutions to help your brand stand out in the digital landscape.",
            homeTagCases: "Successful Cases",
            homeTagData: "Data-Driven",
            homeTagAssets: "Asset Accumulation",
            homeAltPartnership: "Business partners discussing a campaign",
            homeAltAnalytics: "Marketing analytics and growth metrics",
            homeAltTeam: "Creative team planning a campaign",
            homeCtaLine1: "LET'S",
            homeCtaLine2: "WORK",
            homeCtaLine3: "TOGETHER!",
            homeCtaDescription: "Ready to take your brand to the next level? Let's create something extraordinary together.",
            homeCtaButton: "Contact Us",
            // 主页
            agencyName: "The Jasper Hub Agency",
            intro: "Global Influencer Marketing Partner",
            aboutUs: "About Us",
            aboutDesc: "The Jasper Hub Agency is a leading international social media influencer marketing agency, dedicated to helping brands connect with global audiences through authentic influencer partnerships.",
            whyChooseUs: "Why Choose Us",
            reason1: "Proven Global Experience",
            reason1Desc: "We partner with leading brands across diverse app categories, building sustainable growth systems backed by extensive hands-on expertise and measurable results.",
            reason2: "Data-Driven Growth Strategy",
            reason2Desc: "Guided by performance outcomes, we continuously optimize campaigns and content through real-time data insights to drive scalable and sustainable growth.",
            reason3: "Long-Term Growth Assets",
            reason3Desc: "We convert campaign learnings into repeatable growth frameworks, curated creator networks, and high-value content assets that compound long-term marketing efficiency.",
            successCases: "Success Cases",
            brandsWeWorkedWith: "Brands We Have Worked With",
            case1: "Beauty Brand Global Launch",
            case1Desc: "Increased brand awareness by 200% in 3 months with 50+ influencers.",
            case2: "Tech Product Market Expansion",
            case2Desc: "Drove 150% more sales in European markets via targeted influencer campaigns.",
            intro_tag: "Execute successful marketing campaigns",
            intro_sub: "The Top Choice for Global Influencer Marketing",
            // 服务页
            service1: "Global Social Media Influencer Resources",
            service1Desc: "Curated network of influencers across major international platforms (Instagram, TikTok, YouTube, LinkedIn, etc.), covering various niches and regions.",
            service2: "Professional Brand Social Media Marketing Full Planning & Execution",
            service2Desc: "Customized marketing strategies including content creation, campaign planning, and influencer collaboration execution.",
            service3: "Data Tracking & Strategy Adjustment",
            service3Desc: "Real-time data monitoring of campaign performance, timely adjustment of strategies to optimize results.",
            service4: "Phased Review & On-Time Delivery",
            service4Desc: "Regular phased reviews with clients, ensuring all deliverables are completed on schedule and meet expectations.",
            // 联系页
            contactTitle: "CONTACT US",
            contactGreeting: "Thank you for choosing us. We look forward to collaborating with you. Please fill out the form below or contact us via email. We wish you all the best!",
            emailLabel: "Email",
            emailAddress: "business@thejasperhub.com",
            fullName: "Full Name",
            fullNamePlaceholder: "Your full name",
            emailAddressLabel: "Email Address",
            emailAddressPlaceholder: "your@email.com",
            brand: "Brand / Company",
            brandPlaceholder: "Your company name",
            phoneLabel: "Phone Number (Optional)",
            phonePlaceholder: "+1 (555) 123-4567",
            message: "Message",
            messagePlaceholder: "Tell us about your project...",
            submit: "CONTACT US",
            contactSending: "Sending...",
            contactSuccess: "Your message has been sent successfully!",
            contactError: "Failed to send your message. Please try again.",
            talentBreadcrumbHome: "Home",
            talentBreadcrumbAudience: "For Influencers",
            talentBreadcrumbCurrent: "Talent & Agency Inquiries",
            breadcrumb: "Breadcrumb",
            partnershipSupportAria: "Partnership support",
            trustIndicatorsAria: "Partnership trust indicators",
            verifiedDomainsAria: "Verified email domains",
            inquiryFormAria: "Creator and talent inquiry form",
            talentEyebrow: "Global Talent Relations & Partnerships",
            talentTitle: "Collaborate With The Jasper Hub Agency: Talent & Agency Inquiries",
            talentDescription: "Official agency portal for creator agencies, talent management firms, managers, and independent creators seeking roster expansion, verified agency representation, and high-impact brand partnerships.",
            creatorEyebrow: "Global Creator Program",
            creatorTitle: "Collaborate With The Jasper Hub Agency: Global Talents & Creators",
            creatorDescription: "We connect overseas digital creators and global talent with top-tier technology and consumer internet brands.",
            trustVerifiedTitle: "Verified Representation",
            trustVerifiedDesc: "Direct Agency Access",
            trustReviewTitle: "< 24-48hr Review",
            trustReviewDesc: "Talent Manager SLA",
            trustRosterTitle: "Creator Roster",
            trustRosterDesc: "2026 Campaign Network",
            trustReachTitle: "Global Reach",
            trustReachDesc: "Cross-Border Deals",
            authTitle: "Official Domain Authenticity Notice",
            authBadge: "Verified Protocols",
            authDescription: "To safeguard talent agencies, creator managers, and talent partners, all official correspondence is issued strictly through our authenticated namespaces. Beware of impersonators.",
            domainCorporate: "Corporate / Internal",
            domainTalentOps: "Talent Ops",
            domainCampaigns: "Campaign Collabs",
            hotline: "Hotline: info@thejasperhub.com",
            creatorAuthTitle: "Official Verification & Security Advisory",
            creatorAuthBadge: "Verified",
            creatorAuthDescription: "@thejasperhub.com is our main email domain for internal team communication and brand partnership inquiries. For creator collaborations, our team primarily uses @thejasperhub.org and @collabjasperglobal.com. If you are unsure whether a message is genuine, forward it to info@thejasperhub.com for confirmation.",
            talentDeskTitle: "Talent Partnership Desk",
            talentDeskSla: "24-48h Review SLA",
            talentDeskDescription: "Agencies and managers receive dedicated review priority. Our talent liaisons coordinate across London, Hong Kong, and San Francisco to evaluate roster synergy and brand alignment.",
            talentAgencyInquiries: "Talent Agency Inquiries:",
            within24Hours: "Within 24 Hours",
            rosterReview: "Management Roster Review:",
            hours24to48: "24–48 Hours",
            campaignCollab: "Campaign Brand Collab:",
            directManagerSync: "Direct Talent Manager Sync",
            contactCardLabel: "Direct Talent Department Contact",
            contactCardStatus: "Available",
            contactCardName: "Jasper Talent Management Department",
            contactCardAlt: "The Jasper Hub Agency logo",
            contactCardHours: "Mon – Fri, 08:00 – 20:00 HKT / GMT+8",
            industryCitations: "Industry Citations",
            industryTitle: "Trusted By Leading Agencies & Creators",
            industryDescription: "Connecting brands and creators through global influencer marketing partnerships.",
            industryBadgeBrands: "Brand Partnerships",
            industryValueBrands: "100+",
            industryTitleBrands: "Brands Served",
            industryDescBrands: "Experience connecting brands with global audiences.",
            industryBadgeGlobal: "Global Collaboration",
            industryValueGlobal: "Cross-Border",
            industryTitleGlobal: "Creator Partnerships",
            industryDescGlobal: "Connecting international creators and brand campaigns.",
            industryBadgeVerified: "Official Verification",
            industryValueVerified: "Verified",
            industryTitleVerified: "Official Email Domains",
            industryDescVerified: "Confirm agency correspondence through our official contact desk.",
            collaborationAltCreators: "Creative team planning a campaign together",
            collaborationAltAgency: "Business partners meeting in person",
            collaborationAltGlobal: "Team sharing ideas around a campaign plan",
            collaborationCaptionCreators: "Creator partnerships",
            collaborationCaptionAgency: "Agency collaboration",
            collaborationCaptionGlobal: "Global campaigns",
            talentCtaTitle: "LET'S WORK TOGETHER!",
            talentCtaDescription: "Ready to discuss creator representation or a talent partnership? Contact The Jasper Hub Agency.",
            talentCtaContact: "Contact Us",
            talentCtaEmail: "Talent Collab Desk",
            faqTitle: "Questions? We've got answers",
            faqCreatorSubtitle: "Quick answers to common questions.",
            faqTalentSubtitle: "Quick answers to common questions about communication authenticity, agency verification, and influencer protocols.",
            faqQuestionEmail: "What is the contact email address of the Jasper Hub Agency?",
            faqAnswerEmail: "Our main email domain is @thejasperhub.com, which is for internal team communication and business consultation for brand partnerships.",
            faqQuestionCreator: "Which are the email addresses of The Jasper Hub Agency for collaborating with influencers?",
            faqAnswerCreator: "@thejasperhub.org and @collabjasperglobal.com are the main email addresses we use for collaborating with creators. However, in some cases, due to departmental reorganization or organizational structure optimization, we may need to add or optimize some email domain names in order to better maintain our connection with creators.",
            faqQuestionVerify: "How can I determine whether other email addresses belong to The Jasper Hub Agency?",
            faqAnswerVerifyLead: "If you receive any business inquiries from other email addresses claiming to be from our team, we suggest forwarding the email to our official email address (",
            faqAnswerVerifyTail: ") for confirmation. We will respond promptly to let you know whether it is genuine or not, in order to protect your cooperation rights.",
            faqCreatorSupportTitle: "Direct Creator Liaison Support",
            faqCreatorSupportDescription: "Have an urgent campaign query or need immediate contract review?",
            faqCreatorSupportAction: "Email Talent Desk",
            faqTalentSupportDescription: "Still have unresolved questions or need urgent collaboration details?",
            faqTalentSupportVerification: "Contact Verification Desk",
            faqTalentSupportExecutive: "Executive Inquiries",
            talentVerificationAria: "Talent verification support",
            formStep: "Step 1 of 1",
            formRouting: "Inquiry Routing",
            formCreatorTitle: "Creator Representation Application",
            formPartnerTitle: "Creator Partnership & Talent Dispatch",
            formDeskActive: "Talent Partnership Desk Active",
            formHelpLabel: "How can we best help you?",
            formTargetObjective: "Target Objective",
            formSelectType: "Select an inquiry type",
            formCreatorOption: "I am a creator looking for representation",
            formPartnerOption: "Press Inquiries",
            platformTikTok: "TikTok",
            platformYouTube: "YouTube",
            platformInstagram: "Instagram",
            platformTwitter: "Twitter / X",
            platformTwitch: "Twitch",
            platformOther: "Other",
            roleAgency: "Talent Agency",
            roleManagement: "Management Company",
            roleCreator: "Creator / Influencer",
            roleOther: "Other",
            categoryBeauty: "Beauty & Fashion",
            categoryEntertainment: "Entertainment",
            categoryFood: "Food",
            categoryGaming: "Gaming",
            categoryLifestyle: "Lifestyle",
            categoryTechnology: "Technology",
            categoryTravel: "Travel",
            categoryOther: "Other",
            referralSocial: "Social media",
            referralSearch: "Online search",
            referralReferral: "Referral",
            referralOther: "Other",
            formTypeHelp: "For talent agencies, management companies, creator managers, and collaborative talent rosters.",
            formCreatorRegion: "Creator representation details",
            formFullName: "Full Name",
            formEmail: "Email Address",
            formCountry: "Country / Region",
            formSelectCountry: "Select a country or region",
            countryUS: "United States",
            countryUK: "United Kingdom",
            countryCanada: "Canada",
            countryAustralia: "Australia",
            countryGermany: "Germany",
            countrySingapore: "Singapore",
            countryJapan: "Japan",
            countryOther: "Other",
            formRepresented: "Are you currently represented?",
            formYes: "Yes",
            formNo: "No",
            formAgencyName: "Agency Name",
            formAgencyPlaceholder: "Name of your management agency or representative",
            formAudience: "Where's your audience?",
            formActiveChannels: "Select all active channels",
            formSelectedMetrics: "Selected Channel Metrics",
            formPlatformName: "Platform Name",
            formOtherChannel: "Other Channel",
            formProfileUrl: "Profile URL",
            formChannelUrl: "Channel URL",
            formAudienceSize: "Audience Size",
            formPrimaryCategory: "Primary Content Category",
            formSelectCategory: "Select a category",
            formReferral: "How did you hear about us?",
            formSelectOption: "Select an option",
            formReferralOther: "Tell us where you heard about us",
            formAdditionalMessage: "Additional Message",
            formMessagePlaceholder: "Tell us about your upcoming plans or partnership preferences...",
            formOptional: "optional",
            formPartnerRegion: "Talent / Creator Partnerships",
            formOrganization: "Agency / Management Company / Organization",
            formOrganizationPlaceholder: "Agency or Organization name",
            formRole: "Your Role",
            formSelectRole: "Select your role",
            formTalentProfile: "Talent / Creator Name or Profile",
            formTalentPlaceholder: "e.g. @creatorhandle or profile link",
            formPhone: "Phone",
            formPhonePlaceholder: "+1 (555) 000-0000",
            formCollabMessage: "How can we help with this collaboration?",
            formCollabHint: "Detail talent roster sizes, genres, or target brand campaign categories.",
            formCharacters: "{{count}} / {{limit}} characters",
            formSecureRouting: "All communications received via this portal trigger secure PGP-validated routing directly to The Jasper Hub Talent Management Secretariat.",
            formPlatformError: "Select at least one platform to continue.",
            formSending: "Sending...",
            formSubmitCollab: "Submit Collaboration Inquiry",
            formSubmitApplication: "Submit Application",
            formUrgent: "Urgent partnership? Direct talent desk available",
            formMediaKit: "Prefer direct correspondence? Forward media kits to",
            formCreatorSuccess: "Your inquiry has been sent successfully.",
            formPartnerSuccess: "Creator Partnership / Talent Collaboration Inquiry sent successfully.",
            formError: "Unable to send your inquiry. Please try again later.",
            servicesHeroTitle: "How can We Help Brands Succeed.",
            servicesHeroLine1: "How can We",
            servicesHeroLine2: "Help Brands",
            servicesHeroLine3: "Succeed.",
            servicesBannerAlt: "Jasper Hub service strategy banner",
            servicesStrategyImageAlt: "Strategy planning workshop",
            servicesContentImageAlt: "Content creation planning",
            servicesInfluencerImageAlt: "Influencer collaboration",
            servicesStrategyTitle: "Full-Funnel Social Media Marketing Strategy",
            servicesStrategySubtitle: "We build data-led growth models that turn brand and content strategy into measurable product value.",
            servicesStrategy: "Strategy Planning",
            servicesStrategyDesc: "We translate growth goals into a clear testing roadmap, using audience, product, competitor, and performance data to scale what works.",
            servicesContent: "Content Planning",
            servicesContentDesc: "We refine creative structure and storytelling against reach, completion, engagement, and conversion signals to improve retention and action.",
            servicesInfluencer: "Influencer Collaboration",
            servicesInfluencerDesc: "We connect brands with trusted creators, pairing platform insight and creator autonomy to build credibility, reach, and durable campaign value.",
            servicesCooperation: "Cooperation",
            servicesCooperationSubtitle: "An efficient operating rhythm that keeps every brand initiative aligned and moving forward.",
            servicesStepAnalysis: "Marketing Analysis",
            servicesStepAnalysisDesc: "Clarify growth opportunities through product, audience, and market data.",
            servicesStepStrategy: "Strategy Development",
            servicesStepStrategyDesc: "Turn insight into an actionable content, media, and partnership plan.",
            servicesStepExecution: "Campaign Execution",
            servicesStepExecutionDesc: "Coordinate creators and platforms to keep every campaign moving.",
            servicesStepReview: "Performance Review",
            servicesStepReviewDesc: "Review key signals and optimize the next action with speed.",
            servicesStepAlignment: "Strategic Alignment",
            servicesStepAlignmentDesc: "Keep decisions clear, timely, and aligned across every team.",
            // 页脚
            address: "Unit B53, 2/F, Kwai Shing Industrial Building Phase 1, 36-40 Tai Lin Pai Road, Kwai Chung, N.T.",
            copyright: "© 2026 The Jasper Hub Agency. All rights reserved."
        }
    },
    zh: {
        translation: {
            // 导航
            home: "首页",
            services: "服务",
            contact: "联系我们",
            navForInfluencers: "创作者合作",
            navHomeAria: "The Jasper Hub 首页",
            navLogoAlt: "The Jasper Hub 官方标志",
            navOpenMenu: "展开导航菜单",
            navCloseMenu: "收起导航菜单",
            navMainAria: "主导航",
            navPortal: "联系入口",
            siteTitle: "The Jasper Hub | 全球创作者营销与品牌增长",
            siteDescription: "以数据洞察与优质创作者合作，连接全球受众，助力品牌高效获客与长期增长。",
            getStarted: "开始合作",
            forInfluencers: "创作者合作",
            footerForInfluencers: "创作者合作",
            footerBrand: "The Jasper Hub",
            footerAgencyBadge: "营销机构",
            footerDescription: "全球创作者营销合作伙伴。以优质人才、精准策略与高效执行，助力品牌拓展全球市场。",
            footerActivity: "跨境营销活动进行中",
            footerContact: "联系方式",
            footerBusinessEnquiries: "商务合作",
            footerInfluencerQueries: "创作者合作咨询",
            footerHeadquarters: "总部地址",
            footerLinks: "站点链接",
            footerNavigation: "页脚导航",
            loading: "加载中...",
            homeWhyChooseDesc: "以全球资源、数据洞察与长期积累，助力品牌持续增长。",
            homeTagCases: "成功案例",
            homeTagData: "数据驱动",
            homeTagAssets: "长期资产",
            homeAltPartnership: "品牌合作伙伴共同讨论营销活动",
            homeAltAnalytics: "营销数据分析与增长指标",
            homeAltTeam: "创意团队共同规划营销活动",
            homeCtaLine1: "让我们",
            homeCtaLine2: "开始",
            homeCtaLine3: "合作！",
            homeCtaDescription: "让品牌增长更进一步，与我们开启下一次合作。",
            homeCtaButton: "联系我们",
            // 主页
            agencyName: "The Jasper Hub Agency",
            intro: "全球网红营销合作伙伴",
            aboutUs: "关于我们",
            aboutDesc: "The Jasper Hub 专注全球创作者营销，以真实、有影响力的合作连接品牌与全球受众。",
            whyChooseUs: "为什么选择我们",
            reason1: "成熟的全球合作经验",
            reason1Desc: "深耕多个应用赛道，携手领先品牌，以实战经验与可衡量成果构建持续增长体系。",
            reason2: "数据驱动的增长策略",
            reason2Desc: "以成效为导向，实时优化内容与投放策略，让增长更稳定、更具规模。",
            reason3: "沉淀长期增长资产",
            reason3Desc: "积累可复制的增长方法、优质创作者网络与高价值内容，持续提升品牌营销效率。",
            successCases: "成功案例",
            brandsWeWorkedWith: "携手成长的品牌伙伴",
            case1: "美妆品牌全球上线",
            case1Desc: "3个月内通过50+网红合作，品牌知名度提升200%。",
            case2: "科技产品市场拓展",
            case2Desc: "通过精准网红营销，欧洲市场销售额提升150%。",
            intro_tag: "让创意转化为增长",
            intro_sub: "以全球创作者合作，驱动品牌持续增长",
            // 服务页
            service1: "覆盖国际社媒的网红资源",
            service1Desc: "精选Instagram、TikTok、YouTube、领英等主流国际平台的网红资源，覆盖各类细分领域和地区。",
            service2: "专业的品牌社媒营销全案策划和执行",
            service2Desc: "定制化营销方案，包括内容创作、活动策划、网红合作执行等全流程服务。",
            service3: "数据追踪复盘和策略沟通调整",
            service3Desc: "实时监控活动数据表现，及时调整策略以优化营销效果。",
            service4: "阶段性复盘沟通和按时交付",
            service4Desc: "定期与客户进行阶段性复盘，确保所有交付物按时完成并符合预期。",
            // 联系页
            contactTitle: "联系我们",
            contactGreeting: "期待与您共创品牌增长。请填写下方表单，或通过邮箱与我们沟通合作需求。",
            emailLabel: "邮箱",
            emailAddress: "business@thejasperhub.com",
            fullName: "姓名",
            fullNamePlaceholder: "您的姓名",
            emailAddressLabel: "邮箱地址",
            emailAddressPlaceholder: "your@email.com",
            brand: "品牌/公司",
            brandPlaceholder: "您的公司名称",
            phoneLabel: "电话号码（可选）",
            phonePlaceholder: "+1 (555) 123-4567",
            message: "留言",
            messagePlaceholder: "请介绍您的项目与合作需求...",
            submit: "联系我们",
            contactSending: "发送中...",
            contactSuccess: "您的留言已成功发送！",
            contactError: "留言发送失败，请稍后再试。",
            talentBreadcrumbHome: "首页",
            talentBreadcrumbAudience: "创作者合作",
            talentBreadcrumbCurrent: "人才与机构咨询",
            breadcrumb: "面包屑导航",
            partnershipSupportAria: "人才合作支持",
            trustIndicatorsAria: "合作保障",
            verifiedDomainsAria: "官方认证邮箱域名",
            inquiryFormAria: "创作者与人才咨询表单",
            talentEyebrow: "全球人才关系与合作",
            talentTitle: "与 The Jasper Hub Agency 合作：人才与机构咨询",
            talentDescription: "面向人才机构、管理公司、经纪人与独立创作者，提供人才资源对接、机构核验与品牌合作咨询。",
            creatorEyebrow: "全球创作者计划",
            creatorTitle: "与 The Jasper Hub Agency 合作：全球人才与创作者",
            creatorDescription: "连接海外数字创作者与全球人才，携手领先科技及消费互联网品牌。",
            trustVerifiedTitle: "机构认证",
            trustVerifiedDesc: "直达机构团队",
            trustReviewTitle: "24–48小时审核",
            trustReviewDesc: "人才团队响应时效",
            trustRosterTitle: "创作者资源库",
            trustRosterDesc: "2026年合作网络",
            trustReachTitle: "全球覆盖",
            trustReachDesc: "跨境品牌合作",
            authTitle: "官方域名真实性声明",
            authBadge: "认证流程",
            authDescription: "为保障人才机构、创作者经纪人与合作伙伴权益，所有官方沟通均通过已认证域名发送。请警惕冒名信息。",
            domainCorporate: "企业/内部沟通",
            domainTalentOps: "人才运营",
            domainCampaigns: "营销合作",
            hotline: "核验邮箱：info@thejasperhub.com",
            creatorAuthTitle: "官方认证与安全提示",
            creatorAuthBadge: "已认证",
            creatorAuthDescription: "@thejasperhub.com 用于内部团队与品牌合作沟通；创作者合作主要使用 @thejasperhub.org 和 @collabjasperglobal.com。如无法确认邮件真伪，请转发至 info@thejasperhub.com 核验。",
            talentDeskTitle: "人才合作支持",
            talentDeskSla: "24–48小时审核",
            talentDeskDescription: "优先处理机构与经纪人咨询。伦敦、香港与旧金山团队协同评估人才资源，精准匹配品牌合作。",
            talentAgencyInquiries: "人才机构咨询：",
            within24Hours: "24小时内",
            rosterReview: "人才资源审核：",
            hours24to48: "24–48小时",
            campaignCollab: "品牌合作对接：",
            directManagerSync: "直连人才团队",
            contactCardLabel: "直接人才部门沟通",
            contactCardStatus: "在线",
            contactCardName: "Jasper人才管理部门",
            contactCardAlt: "The Jasper Hub Agency 官方标志",
            contactCardHours: "周一至周五，08:00–20:00（香港时间/GMT+8）",
            industryCitations: "行业认可",
            industryTitle: "值得领先机构与创作者信赖",
            industryDescription: "通过全球网红营销合作，连接品牌与创作者。",
            industryBadgeBrands: "品牌合作",
            industryValueBrands: "100+",
            industryTitleBrands: "服务品牌",
            industryDescBrands: "拥有连接品牌与全球受众的实战经验。",
            industryBadgeGlobal: "全球协作",
            industryValueGlobal: "跨境",
            industryTitleGlobal: "创作者合作",
            industryDescGlobal: "连接国际创作者与品牌营销项目。",
            industryBadgeVerified: "官方核验",
            industryValueVerified: "已认证",
            industryTitleVerified: "官方邮箱域名",
            industryDescVerified: "可通过官方联系服务台核验机构邮件。",
            collaborationAltCreators: "创意团队共同策划营销活动",
            collaborationAltAgency: "品牌合作伙伴现场交流",
            collaborationAltGlobal: "团队围绕营销方案分享创意",
            collaborationCaptionCreators: "创作者合作",
            collaborationCaptionAgency: "机构协作",
            collaborationCaptionGlobal: "全球营销项目",
            talentCtaTitle: "让我们一起合作！",
            talentCtaDescription: "准备讨论创作者签约或人才合作？欢迎联系 The Jasper Hub Agency。",
            talentCtaContact: "联系我们",
            talentCtaEmail: "人才合作邮箱",
            faqTitle: "有问题？我们为您解答",
            faqCreatorSubtitle: "快速了解常见问题。",
            faqTalentSubtitle: "快速了解沟通真实性、机构核验与创作者合作规范。",
            faqQuestionEmail: "如何联系 The Jasper Hub Agency？",
            faqAnswerEmail: "我们的主邮箱域名为 @thejasperhub.com，用于内部团队沟通与品牌合作咨询。",
            faqQuestionCreator: "创作者合作使用哪些官方邮箱域名？",
            faqAnswerCreator: "创作者合作主要使用 @thejasperhub.org 与 @collabjasperglobal.com。我们可能因业务调整更新邮箱域名；如有疑问，请通过官方邮箱核验。",
            faqQuestionVerify: "如何确认其他邮箱是否属于 The Jasper Hub Agency？",
            faqAnswerVerifyLead: "如收到声称来自我们团队的其他邮箱发来的合作信息，建议转发至官方邮箱（",
            faqAnswerVerifyTail: "）核验。我们会及时确认信息真伪，保障您的合作权益。",
            faqCreatorSupportTitle: "创作者合作专属支持",
            faqCreatorSupportDescription: "有紧急项目问题，或需要快速审核合同？",
            faqCreatorSupportAction: "联系人才合作邮箱",
            faqTalentSupportDescription: "仍有疑问，或需要紧急了解合作细节？",
            faqTalentSupportVerification: "联系核验服务台",
            faqTalentSupportExecutive: "商务咨询",
            talentVerificationAria: "人才核验支持",
            formStep: "第 1 步，共 1 步",
            formRouting: "咨询分流",
            formCreatorTitle: "创作者签约申请",
            formPartnerTitle: "创作者合作与人才对接",
            formDeskActive: "人才合作服务台在线",
            formHelpLabel: "我们可以如何帮助您？",
            formTargetObjective: "合作目标",
            formSelectType: "请选择咨询类型",
            formCreatorOption: "我是寻求机构合作的创作者",
            formPartnerOption: "人才机构或影响者合作咨询",
            platformTikTok: "TikTok",
            platformYouTube: "YouTube",
            platformInstagram: "Instagram",
            platformTwitter: "Twitter / X",
            platformTwitch: "Twitch",
            platformOther: "其他平台",
            roleAgency: "人才机构",
            roleManagement: "管理公司",
            roleCreator: "创作者/影响者",
            roleOther: "其他",
            categoryBeauty: "美妆与时尚",
            categoryEntertainment: "娱乐",
            categoryFood: "美食",
            categoryGaming: "游戏",
            categoryLifestyle: "生活方式",
            categoryTechnology: "科技",
            categoryTravel: "旅行",
            categoryOther: "其他",
            referralSocial: "社交媒体",
            referralSearch: "网络搜索",
            referralReferral: "朋友推荐",
            referralOther: "其他",
            formTypeHelp: "适用于人才机构、管理公司、创作者经纪人及创作者资源团队。",
            formCreatorRegion: "创作者签约信息",
            formFullName: "姓名",
            formEmail: "邮箱地址",
            formCountry: "国家/地区",
            formSelectCountry: "请选择国家或地区",
            countryUS: "美国",
            countryUK: "英国",
            countryCanada: "加拿大",
            countryAustralia: "澳大利亚",
            countryGermany: "德国",
            countrySingapore: "新加坡",
            countryJapan: "日本",
            countryOther: "其他",
            formRepresented: "目前是否已有经纪机构？",
            formYes: "是",
            formNo: "否",
            formAgencyName: "机构名称",
            formAgencyPlaceholder: "请输入经纪机构或代理人名称",
            formAudience: "您的受众活跃在哪些平台？",
            formActiveChannels: "请选择所有活跃平台",
            formSelectedMetrics: "平台数据",
            formPlatformName: "平台名称",
            formOtherChannel: "其他平台",
            formProfileUrl: "主页链接",
            formChannelUrl: "频道链接",
            formAudienceSize: "受众规模",
            formPrimaryCategory: "主要内容领域",
            formSelectCategory: "请选择内容领域",
            formReferral: "您是如何了解到我们的？",
            formSelectOption: "请选择",
            formReferralOther: "请说明来源",
            formAdditionalMessage: "补充留言",
            formMessagePlaceholder: "请介绍您的近期计划与合作意向...",
            formOptional: "可选",
            formPartnerRegion: "人才/创作者合作",
            formOrganization: "人才机构/管理公司/组织",
            formOrganizationPlaceholder: "请输入机构或组织名称",
            formRole: "您的身份",
            formSelectRole: "请选择您的身份",
            formTalentProfile: "人才/创作者名称或主页",
            formTalentPlaceholder: "例如：@创作者账号或主页链接",
            formPhone: "电话",
            formPhonePlaceholder: "+86 138 0000 0000",
            formCollabMessage: "请说明您的合作需求",
            formCollabHint: "可补充人才库规模、内容领域或目标品牌类别。",
            formCharacters: "{{count}} / {{limit}} 字符",
            formSecureRouting: "通过本入口提交的所有信息，将通过安全的 PGP 验证流程直接发送至 The Jasper Hub 人才管理部门。",
            formPlatformError: "请至少选择一个平台后继续。",
            formSending: "发送中...",
            formSubmitCollab: "提交合作咨询",
            formSubmitApplication: "提交申请",
            formUrgent: "有紧急合作需求？人才服务台可直接响应",
            formMediaKit: "如需直接沟通，可将媒体资料发送至",
            formCreatorSuccess: "您的咨询已成功发送。",
            formPartnerSuccess: "创作者合作与人才对接咨询已成功发送。",
            formError: "咨询发送失败，请稍后再试。",
            servicesHeroTitle: "我们如何助力品牌成功",
            servicesHeroLine1: "我们如何",
            servicesHeroLine2: "助力品牌",
            servicesHeroLine3: "成功",
            servicesBannerAlt: "Jasper Hub 服务策略横幅",
            servicesStrategyImageAlt: "策略规划工作坊",
            servicesContentImageAlt: "内容创作规划",
            servicesInfluencerImageAlt: "创作者合作",
            servicesStrategyTitle: "社交媒体全案营销策划",
            servicesStrategySubtitle: "以数据洞察构建增长模型，用定制化品牌与内容策略放大产品价值。",
            servicesStrategy: "策略规划",
            servicesStrategyDesc: "围绕增长目标，综合分析产品、用户、竞品与内容数据，制定清晰的测试路径，持续放大有效策略。",
            servicesContent: "内容规划",
            servicesContentDesc: "结合曝光、完播、互动与转化数据，优化视频结构与叙事表达，提升用户留存和转化。",
            servicesInfluencer: "创作者合作",
            servicesInfluencerDesc: "链接各平台优质创作者，以平台洞察与创作自主性建立信任，沉淀可持续的品牌合作资源。",
            servicesCooperation: "协作流程",
            servicesCooperationSubtitle: "以高效协作推动品牌持续增长。",
            servicesStepAnalysis: "营销分析",
            servicesStepAnalysisDesc: "梳理产品、用户与市场数据，明确增长机会。",
            servicesStepStrategy: "策略制定",
            servicesStepStrategyDesc: "将数据洞察转化为可执行的内容、投放与合作方案。",
            servicesStepExecution: "投放执行",
            servicesStepExecutionDesc: "协同创作者与平台，稳定推进项目落地。",
            servicesStepReview: "数据复盘",
            servicesStepReviewDesc: "持续复盘关键指标，快速优化下一轮动作。",
            servicesStepAlignment: "会议沟通",
            servicesStepAlignmentDesc: "保持信息同步，让每次决策清晰高效。",
            // 页脚
            address: "香港新界葵涌大連排道36-40號貴盛工業大廈一期2樓B53室",
            copyright: "© 2026 贾斯珀中心营销机构 保留所有权利。"
        }
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "en", // 默认语言
        fallbackLng: "en",
        interpolation: {
            escapeValue: false // React已处理XSS
        }
    });

export default i18n;
